import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import UserInfoForm, { UserInfo } from "../../components/UserInfoForm";
import SocialMediaQuizContainer from "./SocialMediaQuizContainer";
import SocialMediaResults from "./SocialMediaResults";

const SocialMediaQuiz: React.FC = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  const handleUserInfoSubmit = (userData: UserInfo) => {
    setUserInfo(userData);
    navigate("quiz");
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <UserInfoForm
            subtitle="Build Community That Drives Growth"
            onSubmit={handleUserInfoSubmit}
          />
        }
      />
      <Route
        path="quiz"
        element={<SocialMediaQuizContainer userInfo={userInfo} />}
      />
      <Route path="results" element={<SocialMediaResults />} />
    </Routes>
  );
};

export default SocialMediaQuiz;
